import * as React from 'react';

function OpenQuestionBlockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M20.348 19.345h-5.996l-2.678 2.677-2.676-2.677H3A2.001 2.001 0 011 17.344V4C1 2.896 1.896 2 3.001 2h17.347c1.105 0 2.001.897 2.001 2.001v13.343a2.001 2.001 0 01-2.001 2.001zm.667-15.344a.667.667 0 00-.667-.667H3a.667.667 0 00-.666.667v13.343c0 .37.298.668.666.668h6.665l2.008 2.009 2.009-2.009h6.665a.667.667 0 00.667-.668V4.001z"
				fill="#6C7680"
				fillRule="nonzero"
			/>
		</svg>
	);
}

export default OpenQuestionBlockIcon;
